import { request, METHOD } from '../utils/request.js'

// 查看绑定学生
export function getChildInfoList(data) {
  return request(
    '/h5Mfitness/parent/getChildInfoList',
    METHOD.POST,
    data
  )
}
// 查询考证
export function getFaceInfoList(data) {
    return request(
      '/h5Mfitness/parent/getFaceInfoList',
      METHOD.POST,
      data
    )
  }
// 添加准考证
export function insertIntoFaceData(data) {
    return request(
      '/h5Mfitness/parent/insertIntoFaceData',
      METHOD.POST,
      data
    )
  }
  // 检验人脸
export function checkFace(data) {
    return request(
      '/h5Mfitness/com/checkFace',
      METHOD.POST,
      data
    )
  }
  // 作废准考证
  export function updateFaceStatus(data) {
    return request(
      '/h5Mfitness/parent/updateFaceStatus',
      METHOD.POST,
      data
    )
  }
  

  